import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { Industry40View } from "./industry-40-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import "./industry40.scss";
export const Industry40Controller = (props) => {
	const [results, setResults] = useState([]);
	const [tourComplete, setTourComplete] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/home?param=homedata&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, [tourComplete]);

	return (
		<>
			<Helmet>
				<title>Industry 4.0 Dimensions | SmarterChains</title>
				<meta name="description" content="Industry 4.0 Dimensions" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/learning-center">Resource Center</BreadcrumbsItem>
			<BreadcrumbsItem to="/industry-40-dimensions">Industry 4.0 Dimensions</BreadcrumbsItem>
			<Industry40View homeData={results} onTourComplete={setTourComplete} {...props} />
			
		</>
	);
};
